export default {
  columns: {
    desktop: 1
  }, 
  spacing: {
    desktop: 4
  },
  swipeable: {
    desktop: false
  },
  dots: {
    desktop: true
  },
  dotColor: {
    desktop: 'var(--color-primary)'
  },
  dotActiveColor: {
    desktop: 'var(--color-primaryDark)',
  },
  dotSize: {
    desktop: 5
  },
  dotPosition: {
    desktop: -10
  },
  arrows: {
    desktop: false
  },
  arrowsOnHover: {
    desktop: false
  },
  arrowSize: {
    desktop: 18
  },
  arrowColor: {
    desktop: 'var(--color-white)',
  }, 
  arrowBgSize: {
    desktop: 30
  },
  arrowBg: {
    desktop: 'var(--color-primary)',
  },
  arrowPosition: {
    desktop: 10,
    mobile: 0,
  }
}